import { addToast } from 'modules/messageSystem/actions/addToast';

import createAction from './';

export const ON_REMOTE_AUDIO_DISABLE = createAction('ON_REMOTE_AUDIO_DISABLE');
export const ON_REMOTE_AUDIO_ENABLE = createAction('ON_REMOTE_AUDIO_ENABLE');
export const ON_REMOTE_VIDEO_DISABLE = createAction('ON_REMOTE_VIDEO_DISABLE');
export const ON_REMOTE_VIDEO_ENABLE = createAction('ON_REMOTE_VIDEO_ENABLE');
export const SET_REMOTE_VIDEO = createAction('SET_REMOTE_VIDEO');


export const onRemoteAudioDisable = (Name, isGuest) => dispatch => {
  dispatch(addToast(
    'info',
    'remote-audio-disabled-toast',
    {
      id: 'VideoConversation.NotificationChip.DisabledAudio',
      defaultMessage: '** { Name } disabled their audio',
      values: { Name },
    },
    false, null, true, false, null, 3000, 'video'));

  if (!isGuest) {
    dispatch({
      type: ON_REMOTE_AUDIO_DISABLE,
      meta: { audioDisabled: true },
    });
  }
};

export const onRemoteAudioEnable = (Name, isGuest) => dispatch => {
  dispatch(addToast(
    'info',
    'remote-audio-disabled-toast',
    {
      id: 'VideoConversation.NotificationChip.EnabledAudio',
      defaultMessage: '** { Name } enabled their audio',
      values: { Name },
    },
    false, null, true, false, null, 3000, 'video'));
  if (!isGuest) {
    dispatch({
      type: ON_REMOTE_AUDIO_ENABLE,
      meta: { audioDisabled: false },
    });
  }
};

export const onRemoteVideoDisable = (Name, isGuest) => dispatch => {
  dispatch(addToast(
    'info',
    'remote-video-disabled-toast',
    {
      id: 'VideoConversation.NotificationChip.DisabledVideo',
      defaultMessage: '** { Name } disabled their video',
      values: { Name },
    },
    false, null, true, false, null, 3000, 'video'));
  if (!isGuest) {
    dispatch({
      type: ON_REMOTE_VIDEO_DISABLE,
      meta: { videoDisabled: true },
    });
  }
};

export const onRemoteVideoEnable = (Name, isGuest) => dispatch => {
  dispatch(addToast(
    'info',
    'remote-video-enabled-toast',
    {
      id: 'VideoConversation.NotificationChip.EnabledVideo',
      defaultMessage: '** { Name } enable their video',
      values: { Name },
    },
    false, null, true, false, null, 3000, 'video'));
  if (!isGuest) {
    dispatch({
      type: ON_REMOTE_VIDEO_ENABLE,
      meta: { videoDisabled: false },
    });
  }
};


export const setRemoteVideo = (remoteVideo) => ({
  type: SET_REMOTE_VIDEO,
  meta: { remoteVideo },
});
